export function imageUrl(event, { width, height, fit = 'cover', focalX, focalY } = {}) {
    if (typeof event !== 'object') {
        return;
    }

    const src = event.image?.src;

    if (!src) {
        return;
    }

    const params = [];
    if (width) params.push(`width=${width}`);
    if (height) params.push(`height=${height}`);
    if (fit) params.push(`fit=${fit}`);
    // Use != null so a legitimate 0 (hard left/top focal point) is preserved.
    if (focalX != null) {
        params.push(`fx=${focalX}`);
    } else if (event.image.focalX != null) {
        params.push(`fx=${event.image.focalX}`);
    }

    if (focalY != null) {
        params.push(`fy=${focalY}`);
    } else if (event.image.focalY != null) {
        params.push(`fy=${event.image.focalY}`);
    }

    const separator = src.includes('?') ? '&' : '?';
    const queryString = params.length > 0 ? `${separator}${params.join('&')}` : '';

    return `${src}${queryString}`;
}
